import type { AppIconProps } from '../Icons.types';
import { getClassNames } from '../Icons.utils';
import styles from './Edit.module.scss';

export const AppEditIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;
  const classNames = getClassNames(styles.icon, className);

  return (
    <svg
      {...rest}
      className={classNames}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99935 4.33321L11.666 6.99988M8.6661 13.4999H13.3328M2.66602 13.3332H5.33268L12.3327 6.33321C12.6863 5.97959 12.885 5.49997 12.885 4.99988C12.885 4.49978 12.6863 4.02016 12.3327 3.66654C11.9791 3.31292 11.4994 3.11426 10.9993 3.11426C10.4993 3.11426 10.0196 3.31292 9.66602 3.66654L2.66602 10.6665V13.3332Z"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
